import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-challenge-details',
    templateUrl: './challenge-details.component.html',
    styleUrls: ['./challenge-details.component.scss'],
    standalone: false
})
export class ChallengeDetailsComponent implements OnInit {
  challenge: any;
  usedOnMobile: any;
  productId: any;
  competitorId: any;
  constructor(public dialogRef: MatDialogRef<ChallengeDetailsComponent>,
              private dataService: DataService,
              public authService: AuthService,
              public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router) {
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.competitorId = router.routerState.snapshot.root.children[0].children[0].params.competitorId;
                this.challenge = this.data.challenge;
              }

  ngOnInit(): void {
    this.dataService.get('product/CompetitorPositioning/RetrieveCompetitorPositioningById/' + this.productId + '/' + this.challenge.id).then((data) => {
      if (data.statusCode === 200) {
        this.challenge = data.data;
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  usedOnMobileToggle(event: any) {
    this.usedOnMobile = event.source.checked;
    const payload = {
      ProductId: parseInt(this.productId.toString(), 10),
      CompetitorPositioningId: parseInt(this.challenge.id.toString(), 10),
      ProductCompetitorId: parseInt(this.competitorId.toString(), 10),
      usedOnMobile: this.usedOnMobile
    };
    this.dataService.put('product/CompetitorPositioning/UpdateUsedOnMobile', payload).then((data) => {
      if (data.statusCode === 200) {
        this.dialogRef.close(payload);
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile updated successfully',
            buttonText: 'Ok'
          }
        });
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  truncate(string: string) {
    if (string.length  > 32) {
      string = string.slice(0, 32) + '...';
    }
    return string;
  }

  forceDownload(blob, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url, filename) {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/octet-stream'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      this.forceDownload(blobUrl, filename);
    })
    .catch(err => {
      this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    });
  }

  downloadMyFile(url: any, fileName: any) {
    if (url) {
      this.downloadResource(url , fileName);
    }
  }
  
  downloadMyFileAndLog(challenge: any) {
    if (!challenge) return;

    const isValidFile = this.isValidFileExtension(challenge.path);
    if (!isValidFile) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'This is a Link',
          type: 'Info',
          message: 'The selected resource is a link and cannot be downloaded directly.',
          buttonText: 'Ok'
        }
      });
      return;
    }

    this.logMaterial(challenge.id);

    this.downloadMyFile(challenge.path, challenge.name);
  }

  logMaterial(id: any) {
    let materialLookup
    let materialId!: number;
    this.dataService.getMaterialTypes().then((data: any) => {
      materialLookup = data;
      for (let index = 0; index < materialLookup.length; index++) {
        const element = materialLookup[index];
        if (element.name === "ProductCopmetitorChallengeSupportMaterials") {
          materialId = element.id;
        }
      }
      this.dataService.post('DownloadMaterial/DownloadProductMaterial/' + +materialId + '/' + id, null).then((data) => {
      });

    });
  }
  
  isValidFileExtension(filePath: string): boolean {
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'txt', 'html', 'pdf', 'rtf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

    const fileExtension = filePath.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(fileExtension!);
  }
}
